import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'layerIcon',
    standalone: false
})
export class LayerIconPipe implements PipeTransform {
  readonly iconsByLayerType = new Map<string, string>([
    ['Node', 'ct-node'],
    ['Pipe', 'ct-pipe'],
    ['Hydrant', 'ct-hidrant'],
    ['Pump', 'ct-pump'],
    ['Reservoir', 'ct-reservoir'],
    ['Digital-Object', 'ct-digital-object'],
    ['Validation-Object', 'ct-validation-object'],
    ['Pressure-Control-Zone', 'ct-pressure-control-zone'],
    ['Flow-Control-Zone', 'ct-flow-control-zone'],
    ['Shutoff-Valve', 'ct-shutoff-valve'],
    ['Source', 'ct-source'],
    ['Valve', 'ct-valve'],
    ['Accumulator', 'ct-accumulator'],
    ['ACV', 'ct-acv'],
    ['Consumer', 'ct-consumer'],
    ['Heat-Exchanger', 'ct-heat-exchanger'],
    ['Heater', 'ct-heater'],
    ['IDO', 'ct-Ido'],
    ['Line', 'ct-line'],
    ['IIO', 'ct-IIo'],
    ['Mea-Object', 'ct-mea-object'],
    ['Plant', 'ct-plant'],
    ['Point', 'ct-point'],
    ['Poligon', 'ct-poligon'],
    ['Service-Pipe', 'ct-service-pipe'],
    ['Shunt', 'ct-shunt'],
    ['Text', 'ct-text'],
    ['Heatmap', 'drag_and_drops'],
    ['default', ''],
  ]);

  transform(type: string): string {
    if (this.iconsByLayerType.has(type)) {
      return this.iconsByLayerType.get(type);
    } else {
      return this.iconsByLayerType.get('default');
    }
  }
}
